<template>
  <v-sheet color="primary lighten-2" class="galleries py-8 py-sm-10 py-md-16">
    <LoadingWidget v-if="loading" />
    <div v-if="!loading">
      <transition name="fade">
        <v-container>
          <div
            class="
              text-h3 text-sm-h2 text-md-h1
              white--text
              d-flex
              justify-center
            "
          >
            <span class="galleries-title">Galerias de Fotos</span>
          </div>
          <div class="pt-10 relative">
            <VueSlickCarousel
              class="vue-slick-carousel mx-n4"
              v-bind="settingsCarrousel"
              ref="carousel"
            >
              <template v-for="(item, itemsKey) in galleries">
                <div class="px-8 px-sm-4 item" :key="itemsKey">
                  <img
                    @click="
                      images = item.images;
                      index = 0;
                      galleryOpened = true;
                    "
                    class="item-img"
                    width="100%"
                    :src="item.img"
                  />
                  <div
                    class="
                      d-flex
                      justify-center
                      font-weight-bold
                      white--text
                      text-sm-h5 text-body-1
                      pt-sm-6 pt-3
                    "
                  >
                    {{ item.title }}
                  </div>
                </div>
              </template>
            </VueSlickCarousel>
            <div
              v-if="showArrows"
              class="d-flex justify-space-between vue-slick-carousel-nav"
            >
              <v-btn
                class="transparent pa-md-2"
                :height="smAndDown ? `24px` : `auto`"
                :width="smAndDown ? `24px` : `auto`"
                icon
                text
                @click="showPrev"
              >
                <v-icon color="white" :size="smAndDown ? 15 : 20">
                  fas fa-chevron-left
                </v-icon>
              </v-btn>
              <v-btn
                class="transparent pa-md-2"
                :height="smAndDown ? `24px` : `auto`"
                :width="smAndDown ? `24px` : `auto`"
                icon
                text
                @click="showNext"
              >
                <v-icon color="white" :size="smAndDown ? 15 : 20">
                  fas fa-chevron-right
                </v-icon>
              </v-btn>
            </div>
          </div>
          <CoolLightBox
            :items="images"
            :index="index"
            @close="(index = null), (galleryOpened = false)"
          />
        </v-container>
      </transition>
    </div>
  </v-sheet>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import LoadingWidget from "../../widgets/LoadingWidget.vue";

const _config = {
  mod: "attitudes-award-galleries",
};
export default {
  data: () => ({
    index: null,
    loading: true,
    galleries: [],
    images: [],
    galleryOpened: false,
    settings: {
      swipe: true,
      dots: false,
      infinite: true,
      arrows: false,
      slidesToScroll: 3,
      slidesToShow: 3,
      pauseOnHover: true,
      pauseOnDotsHover: true,
    },
  }),
  methods: {
    getAllGalleries() {
      this.$rest(_config.mod)
        .get()
        .then(
          (data) =>
            (this.galleries = data
              .filter(({ img, title }) => {
                if (img.list && title && img.featured) {
                  return {
                    img,
                    title,
                  };
                }
              })
              .map(({ id, img, title }) => ({
                id,
                title,
                img: this.files + img.featured + "?resize=1&w=400",
                images: img.list.map((item) => {
                  return this.files + item.path;
                }),
              })))
        )
        .then(() => (this.loading = false));
    },
    showNext() {
      this.$refs.carousel.next();
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    showArrows() {
      if (this.smAndDown) {
        return this.galleries.length > 2 ? true : false;
      }
      if (this.xsOnly) {
        return this.galleries.length > 1 ? true : false;
      }
      return this.galleries.length > 3 ? true : false;
    },
    settingsCarrousel() {
      return {
        ...this.settings,
        draggable: this.galleries.length > 3 ? true : false,
        autoplay: this.galleryOpened ? false : true,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              draggable: this.galleries.length > 2 ? true : false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              draggable: this.galleries.length > 1 ? true : false,
            },
          },
        ],
      };
    },
  },
  created() {
    this.getAllGalleries();
  },
  components: {
    LoadingWidget,
    VueSlickCarousel,
    CoolLightBox,
  },
};
</script>
<style lang="scss" scoped>
.vue-slick-carousel-nav {
  left: -50px;
  position: absolute;
  right: -50px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  button {
    pointer-events: all;
  }
  @media (max-width: 960px) {
    right: -10px;
    left: -10px;
  }
}

.galleries {
  &-title {
    font-family: "Get Show", cursive;
  }
}
.item-img {
  cursor: pointer;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  box-shadow: 0px 16px 32px -16px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
}
</style>
